import { combineReducers, createStore, applyMiddleware } from "redux";
import ReduxThunk from "redux-thunk";
import { persistStore } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension";
import { authReducer as auth } from "./auth";
import { globalReducer as global } from "./global";

const asyncReducers = {};

const createReducer = (asyncReducers = {}) => combineReducers({
  // blank: state => (state || []),
  auth,
  global,
  ...asyncReducers
});

const store = createStore(createReducer(),
  composeWithDevTools(applyMiddleware(ReduxThunk)));

store.injectAsyncReducer = (name, asyncReducer) => {
  asyncReducers[name] = asyncReducer;
  store.replaceReducer(createReducer(asyncReducers));
};

export default {
  store,
  persist: persistStore(store)
};
